import type { AutoPopulationPollingStatus } from '@shared/utils/accommodations/autoPopulation/types';

export type EmptyStateSuggestAction = 'openSuggestDialog' | 'browse';

/**
 * Routing for the empty-state "Suggest" CTA. The suggest dialog's hotel options need a venue and a
 * non-pending auto-population state to do anything; without a venue we route to the browse/add flow
 * instead of a dead-end dialog (mirrors the venue-gated header Suggest action).
 */
export const getEmptyStateSuggestAction = (hasVenue: boolean, autoPopulationStatus: AutoPopulationPollingStatus): EmptyStateSuggestAction =>
  hasVenue && autoPopulationStatus !== 'PENDING' ? 'openSuggestDialog' : 'browse';
